export const getDeliveries = (state) => state.deliveriesContent.deliveriesData;
export const getLoading = (state) => state.deliveriesContent.isLoading;
export const getBarcodeByColisLoading = (state) => state.deliveriesContent.isGetBarcodeByColisLoading
export const getCreateLoading = (state) => state.deliveriesContent.isCreateLoading;
export const getUpdateLoading = (state) => state.deliveriesContent.isUpdateLoading;
export const getCreatedStatus = (state) => state.deliveriesContent.status;
export const getCreatedData = (state) => state.deliveriesContent.createdData;
export const getBarcodeList = (state) => state.deliveriesContent.barcodeList;
